import { wrapperBuilder } from './build';
const variables = wrapperBuilder.getVariablesRegisterInstance();

variables.addVariable('contribution', { startValue: undefined });
variables.addVariable('paymentStatus', { startValue: 'NOT_STARTED' });
variables.addVariable('paymentMessage', { startValue: '' });
